type Optional<T> = T | null | undefined;

interface HasItems {
  <T extends readonly unknown[]>(array: Optional<T>): array is T;
  <T extends unknown[]>(array: Optional<T>): array is T;
}

/**
 * 배열에 요소가 있는지 확인하는 함수입니다.
 * 배열이 배열 타입이고 요소가 하나 이상 있는 경우에만 `true`를 반환합니다.
 *
 * @typeParam T - 배열 요소의 타입.
 * @param array - 확인할 배열.
 * @returns - 배열에 요소가 있는 경우 `true`, 그렇지 않으면 `false`.
 */
export const hasItems: HasItems = <T extends readonly unknown[] | unknown[]>(array: Optional<T>): array is T => {
  return Array.isArray(array) && array.length > 0;
};
